import Vue from 'vue'

import logger from '@/utils/logger'

import {
  collectRevealTargets,
  createReveal,
  isRevealAllowed,
} from '@/utils/scrollReveal'

/*
 * Анимация появления блоков при открытии страницы и при скролле.
 *
 * `v-reveal` — анимируем сам элемент.
 * `v-reveal-group` — анимируем детей элемента или блоки по селектору.
 * Значение директивы: { selector, delay }, обе части опциональны.
 * Блоки, попавшие в кадр вместе, появляются каскадом с задержкой REVEAL_STEP_MS.
 */

/* Контроллеры анимации по элементу, на котором стоит директива */
const controllers = new WeakMap()

const resolveTargets = (el, value, isGroup) => {
  if (value.selector) {
    return collectRevealTargets(el, value.selector)
  }

  if (isGroup) {
    return Array.from(el.children)
  }

  return [el]
}

const startReveal = (el, binding, isGroup) => {
  // Пользователь просил уменьшить движение — оставляем блоки как есть
  if (!isRevealAllowed()) {
    return
  }

  const value = binding.value || {}
  const targets = resolveTargets(el, value, isGroup)

  if (!targets.length) {
    logger.warn('v-reveal: блоки для анимации не найдены', value.selector || el)

    return
  }

  controllers.set(el, createReveal(targets, { delay: value.delay }))
}

const stopReveal = (el) => {
  controllers.get(el)?.disconnect()
  controllers.delete(el)
}

Vue.directive('reveal', {
  inserted(el, binding) {
    startReveal(el, binding, false)
  },
  unbind: stopReveal,
})

Vue.directive('reveal-group', {
  inserted(el, binding) {
    startReveal(el, binding, true)
  },
  unbind: stopReveal,
})
